import { isObject } from '@utils/type-guards/is-object'
import { ColorSliderAnalyticsData } from '../../types/analytics/analytics-data'

export const isColorSliderAnalyticsData = (obj: unknown): obj is ColorSliderAnalyticsData => {
  return isObject(obj) && typeof obj.weaveName === 'string' && obj.CONTENT_TYPE == undefined
}
